import {getConfig} from 'api';
import Utils from "../utils/utils";

const $=window.jQuery;

class ProductDetails {

    constructor(lang, enableDebug) {
        this.lang = lang;
        this.enableDebug = enableDebug;
    }

    async run() {
        const productDetailRoot = $('[id^="ProductDetail__erp"]');
        // Product Detail root id attr looks like: "ProductDetail__erp.ro.b2c/prod/S85-EU-BK-NE"
        const productId = productDetailRoot.attr('id').slice(31, 100);
        this.currentProductId = productId;

        console.log(`>> Initializing Product Details code, productId=${productId}`);

        this.config = window['roProductsConfig'];
        if (!this.config) {
            console.error('roProductsConfig not found, skipping code execution');
            return;
        }

        const config = this.getProductConfig();
        if (!config) {
            console.info('No config found for current product, skipping');
            return;
        }

        this.productConfig = config;

        for (const [opId, opConfig] of Object.entries(config)) {
            // console.log('Testing op', opId);
            if (opId in this &&
                typeof this[opId] === "function") {
                console.log('Found op', opId);

                this[opId](opConfig).catch((e) => {
                    console.info(`Could not apply op ${opId} for product ${this.currentProductId}`);
                });

            }
        }

    }

    getProductConfig() {
        if (!this.config.js[this.currentProductId]) return null;
        const productConfig = this.config.js[this.currentProductId];
        if (productConfig.debug && !this.enableDebug) {
            console.log(`Not applying config for product ${this.currentProductId} since it's configured as a debug product but debug option is not enabled`);
            return null;
        }
        return productConfig;
    }

    async label(config)
    {
        console.log(`>>> Adding top label for product code ${this.currentProductId}`);
        (await Utils.wait('.ProductDetails__information'))
            .prepend(config[this.lang]);
    }

    async bestSellerLabel2(config)
    {
        console.log(`>>> Adding bestSellerLabel2 for product code ${this.currentProductId}`);
        const labelHTML = config[this.lang];

        try {
            const ratingsContainer = await Utils.wait('.ProductDetails__rating-container');
            console.log('Found ratings container')
            $(labelHTML).insertAfter(ratingsContainer);
        } catch (e) {
            try {
                const colorSwitcher = await Utils.wait('.ProductDetails__colorSwitcher');
                console.log('Found color switcher container')
                $(labelHTML).insertBefore(colorSwitcher);
            } catch (e) {
                try {
                    const marketingFeatures = await Utils.wait('.ProductDetails__marketingFeatures');
                    console.log('Found color marketing features container')
                    marketingFeatures.append(labelHTML);
                } catch(e) {
                    console.log('Could not find any of the elements required to show bestSellerLabel2')
                }
            }
        }
    }

    async promoBadge(config)
    {
        console.log(`>>> Adding promoBadge for product code ${this.currentProductId}`);
        (await Utils.wait(`[id$="${this.currentProductId}"] .ProductDetails__information`))
            .prepend(config.PDP);
    }

    async newPrice(config)
    {
        console.log(`>>> Adding newPrice for product code ${this.currentProductId}`);
        (await Utils.wait(`[id$="${this.currentProductId}"] .ProductDetails__information .ProductDetails__price`))
            .addClass('genericPriceColor');
        (await Utils.wait(`[id$="${this.currentProductId}"] .ProductDetails__information .ProductDetails__price`))
            .append(config.PDP);
    }

    async machinePromoOfferDetailsPDP(config)
    {
        console.log(`>>> Adding machinePromoOfferDetailsPDP for product code ${this.currentProductId}`);

        (await Utils.wait(`[id$="${this.currentProductId}"] .ProductDetails__header`))
            .append(config);
    }

    async shortDescription(config)
    {
        console.log(`>>> Adding shortDescription for product code ${this.currentProductId}`);

        (await Utils.wait(`[id$="${this.currentProductId}"] .ProductDetails__information`))
            .append(config);
    }

    async specialOffer(config)
    {
        console.log(`>>> Adding specialOfferLabel for product code ${this.currentProductId}`);

        (await Utils.wait(`[id$="${this.currentProductId}"] .ProductDetails__information .ProductDetails__range`))
            .append(config);
    }

    async capsuleNewLabel(config)
    {
        console.log(`>>> Adding capsuleNewLabel for product code ${this.currentProductId}`);
        (await Utils.wait(`[id$="${this.currentProductId}"] .ProductDetails__range`))
            .prepend(config.PDP);
    }

    async capsuleFreeDeliveryLabel(config)
    {
        console.log(`>>> Adding capsuleFreeDeliveryLabel for product code ${this.currentProductId}`);
        (await Utils.wait(`[id$="${this.currentProductId}"] .ProductDetails__flavors`))
            .append(config.PDP);
    }

    async capsulePromoBadge(config)
    {
        console.log(`>>> Adding capsulePromoBadge for product code ${this.currentProductId}`);
        (await Utils.wait(`[id$="${this.currentProductId}"] .ProductDetails__information`))
            .append(config.PDP);
    }

    async machineNewLabel(config)
    {
        console.log(`>>> Adding machineNewLabel for product code ${this.currentProductId}`);
        (await Utils.wait(`[id$="${this.currentProductId}"] .ProductDetails__range`))
            .prepend(config.PDP);
    }

    async machineBestSellerLabel(config)
    {
        console.log(`>>> Adding machineBestSellerLabel for product code ${this.currentProductId}`);
        (await Utils.wait(`[id$="${this.currentProductId}"] .ProductDetails__range`))
            .prepend(config.PDP);
    }

    async accessoriesBestSellerLabel(config)
    {
        console.log(`>>> Adding accessoriesBestSellerLabel for product code ${this.currentProductId}`);
        (await Utils.wait(`[id$="${this.currentProductId}"] .ProductDetails__marketingFeatures`))
            .prepend(config.PDP);
    }

    async machineSubscription(config)
    {
        console.log(`>>> Adding machineSubscription for product code ${this.currentProductId}`);
        (await Utils.wait(`[id$="${this.currentProductId}"] .ProductDetails__taxes-information`))
            .prepend(config.PDP);
    }

}

export default ProductDetails;
